import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { withTheme, withStyles } from '@material-ui/core/styles'
import { Typography, Box } from '@material-ui/core'
import MuiAccordion from '@material-ui/core/Accordion'
import AccordionSummary from '@material-ui/core/AccordionSummary'
import AccordionDetails from '@material-ui/core/AccordionDetails'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'

const Accordion = withStyles({
  root: {
    borderTop: '1px solid rgba(0, 0, 0, .125)',
    border: 'unset',
    '&.MuiAccordion-root.Mui-expanded': {
      margin: 'unset',
    },
    '&.MuiAccordion-rounded:first-child': {
      borderRadius: 'unset',
    },
    '&:before': {
      backgroundColor: 'unset',
    },
  },
})(MuiAccordion)

const Collapsible = ({
  children,
  title,
  className,
  defaultIsActive,
  titleRight,
}) => {
  const [expanded, setExpanded] = useState(defaultIsActive)
  const onClick = () => setExpanded(!expanded)

  return (
    <Accordion className={className} expanded={expanded}>
      <AccordionSummary onClick={onClick} expandIcon={<ExpandMoreIcon />}>
        <Typography variant="h4" component="h4">
          {title}
        </Typography>
        {titleRight && <Box ml="auto">{titleRight}</Box>}
      </AccordionSummary>
      <AccordionDetails>{children}</AccordionDetails>
    </Accordion>
  )
}

Collapsible.defaultProps = {
  title: '',
  className: 'trainingPackage',
  defaultIsActive: false,
  titleRight: '',
}

Collapsible.propTypes = {
  title: PropTypes.shape({
    id: PropTypes.string,
    defaultMessage: PropTypes.string,
  }),
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
  defaultIsActive: PropTypes.bool,
  titleRight: PropTypes.string,
}

export default withTheme(Collapsible)
